export const environment = {
  production: false,
  base_url: 'https://gandee.click/',
  api_url: 'https://api-preprod.gandee.click/api/v1/',
  api_url_v2: 'https://gandee.click/api/v2', // API v2 pour Stripe
  stripe_onboarding_url: "stripe-connect-flow?id_association=",
};
